import { ErrorStateScheduleEnum } from '../error-state-schedule.enum';

export enum PanelOrderRoutesResolverErrorStatesEnum {
    GetBrokersFailed = ErrorStateScheduleEnum.PanelOrderRoutesResolverErrorStatesStartIndex,
    GetBrokerSearchExtendedFailed,
    GetParentResolverDataFailed,
    GetBrokerAvailableTriggersFailed,
    GetRoutesFailed,
    GetRouteSetsFailed,
}
